import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Strapi from '../../services/strapi';
import { TextField } from '@material-ui/core';
import ArticleField from '../../atoms/ArticleField';

interface KeywordsProps {
  onChange?: (newValue: any) => void,
	value?: any,
}

const Keywords = ( props: KeywordsProps ) => {
  const [options, setOptions] = useState<any[]>([]);
  const [inputValue, setInputValue] = useState<string>("");
  
  useEffect(() => {
    const params: any = { _limit: 10 };
    params["content_contains"] = inputValue;

    Strapi.get("mot-cles", params, {}).then((r) => {
      setOptions(r);
    });
    return () => {
    }
  }, [inputValue])

  return <ArticleField label="Mot-clés *">
    <Autocomplete
      multiple
      value={props.value}
      options={options}
      onInputChange={(_, newValue) => {
        setInputValue(newValue);
      }}
      renderInput={(params) => (
        <TextField {...params} fullWidth/>
      )}
      getOptionLabel={(option) => option.content}
      freeSolo
      onChange={async (e, changedValue) => {
        let new_value = changedValue;
        if (typeof new_value[new_value.length - 1] === "string") {
          new_value[new_value.length - 1] = await Strapi.post("mot-cles", {}, {
            content: new_value[new_value.length - 1],
          });
        }
        if (props.onChange) {
          props.onChange(new_value);
        }
      }}
    />
  </ArticleField>
}

export default Keywords;